import { apiGet } from 'utils/API/actions/request'
import { PAYMENTTYPES_REGISTRATION } from '../constants'

export const fetchRegistration = (appid, accessId) => apiGet({
  entity: PAYMENTTYPES_REGISTRATION,
  url: `/registration/${appid}`,
  config: {
    params: {
      accessId
    }
  }
})
